// === FILENAME: src/data/teamData.js ===
// Plantel del Club Deportivo Villa del Dique — Temporada 2026
// Los valores x/y están en porcentaje (0–100) sobre la cancha (x = horizontal, y = vertical)

export const formation = '4-3-3';

export const starters = [
  // — Arquero
  {
    id: 1,
    number: 1,
    firstName: 'Matías',
    lastName: 'Villarreal',
    position: 'Arquero',
    positionShort: 'POR',
    age: 29,
    nationality: 'Argentino',
    height: '1.88 m',
    since: 2021,
    x: 50,
    y: 90,
    stats: { partidos: 18, vallasInvictas: 7, atajadas: 62 },
    bio: 'Capitán del equipo y líder en el arco. Surgido de las inferiores, es el referente de la defensa.',
  },

  // — Defensa (4)
  {
    id: 2,
    number: 4,
    firstName: 'Lucas',
    lastName: 'Pereyra',
    position: 'Lateral Derecho',
    positionShort: 'LD',
    age: 24,
    nationality: 'Argentino',
    height: '1.78 m',
    since: 2023,
    x: 82,
    y: 72,
    stats: { partidos: 16, goles: 1, asistencias: 3 },
    bio: 'Veloz por la banda, aporta mucho en ataque con sus desbordes y centros.',
  },
  {
    id: 3,
    number: 2,
    firstName: 'Federico',
    lastName: 'Roldán',
    position: 'Defensor Central',
    positionShort: 'DFC',
    age: 28,
    nationality: 'Argentino',
    height: '1.86 m',
    since: 2020,
    x: 62,
    y: 75,
    stats: { partidos: 17, goles: 2, despejes: 95 },
    bio: 'Pilar defensivo, fuerte en el juego aéreo y con buena salida de pelota.',
  },
  {
    id: 4,
    number: 6,
    firstName: 'Santiago',
    lastName: 'Ibáñez',
    position: 'Defensor Central',
    positionShort: 'DFC',
    age: 26,
    nationality: 'Argentino',
    height: '1.84 m',
    since: 2022,
    x: 38,
    y: 75,
    stats: { partidos: 18, goles: 1, despejes: 88 },
    bio: 'Zaguero aguerrido, líder en el fondo junto a Roldán.',
  },
  {
    id: 5,
    number: 3,
    firstName: 'Emiliano',
    lastName: 'Cabrera',
    position: 'Lateral Izquierdo',
    positionShort: 'LI',
    age: 23,
    nationality: 'Argentino',
    height: '1.75 m',
    since: 2024,
    x: 18,
    y: 72,
    stats: { partidos: 15, goles: 0, asistencias: 4 },
    bio: 'Lateral izquierdo con proyección ofensiva. Formado en el club desde los 10 años.',
  },

  // — Mediocampo (3)
  {
    id: 6,
    number: 5,
    firstName: 'Gonzalo',
    lastName: 'Martínez',
    position: 'Mediocampista Central',
    positionShort: 'MC',
    age: 27,
    nationality: 'Argentino',
    height: '1.80 m',
    since: 2021,
    x: 50,
    y: 55,
    stats: { partidos: 18, goles: 3, asistencias: 5 },
    bio: 'El cerebro del equipo. Distribuye el juego y recupera pelotas.',
  },
  {
    id: 7,
    number: 8,
    firstName: 'Joaquín',
    lastName: 'Ríos',
    position: 'Interior Derecho',
    positionShort: 'INT',
    age: 22,
    nationality: 'Argentino',
    height: '1.76 m',
    since: 2023,
    x: 72,
    y: 50,
    stats: { partidos: 17, goles: 4, asistencias: 6 },
    bio: 'Joven volante con mucha llegada al área rival. Promesa del club.',
  },
  {
    id: 8,
    number: 10,
    firstName: 'Diego',
    lastName: 'Fernández',
    position: 'Enganche',
    positionShort: 'ENG',
    age: 30,
    nationality: 'Argentino',
    height: '1.74 m',
    since: 2019,
    x: 28,
    y: 50,
    stats: { partidos: 16, goles: 6, asistencias: 9 },
    bio: 'El 10 del equipo. Con técnica y visión de juego, es el dueño de la pelota parada.',
  },

  // — Delantera (3)
  {
    id: 9,
    number: 7,
    firstName: 'Bruno',
    lastName: 'Ortega',
    position: 'Extremo Derecho',
    positionShort: 'ED',
    age: 25,
    nationality: 'Argentino',
    height: '1.77 m',
    since: 2022,
    x: 78,
    y: 28,
    stats: { partidos: 18, goles: 8, asistencias: 7 },
    bio: 'Velocidad y gambeta. Su desequilibrio por la derecha es clave para el ataque.',
  },
  {
    id: 10,
    number: 9,
    firstName: 'Facundo',
    lastName: 'Quiroga',
    position: 'Centrodelantero',
    positionShort: 'DC',
    age: 28,
    nationality: 'Argentino',
    height: '1.83 m',
    since: 2020,
    x: 50,
    y: 22,
    stats: { partidos: 18, goles: 14, asistencias: 3 },
    bio: 'Goleador histórico del club. Oportunista y letal en el área.',
  },
  {
    id: 11,
    number: 11,
    firstName: 'Tomás',
    lastName: 'Aguirre',
    position: 'Extremo Izquierdo',
    positionShort: 'EI',
    age: 21,
    nationality: 'Argentino',
    height: '1.73 m',
    since: 2024,
    x: 22,
    y: 28,
    stats: { partidos: 16, goles: 5, asistencias: 4 },
    bio: 'Zurdo habilidoso, promete un gran futuro. Es el "Dibujito" de la hinchada.',
  },
];

export const substitutes = [
  {
    id: 12,
    number: 12,
    firstName: 'Martín',
    lastName: 'Navarro',
    position: 'Arquero Suplente',
    positionShort: 'POR',
    age: 21,
    nationality: 'Argentino',
    height: '1.87 m',
    since: 2023,
    stats: { partidos: 4, vallasInvictas: 1, atajadas: 12 },
    bio: 'Joven arquero con gran proyección. Segundo arquero del plantel.',
  },
  {
    id: 13,
    number: 14,
    firstName: 'Iván',
    lastName: 'Suárez',
    position: 'Defensor',
    positionShort: 'DF',
    age: 25,
    nationality: 'Argentino',
    height: '1.82 m',
    since: 2022,
    stats: { partidos: 10, goles: 0, despejes: 32 },
    bio: 'Puede jugar de central o de lateral. Muy versátil.',
  },
  {
    id: 14,
    number: 15,
    firstName: 'Agustín',
    lastName: 'Molina',
    position: 'Mediocampista',
    positionShort: 'MC',
    age: 23,
    nationality: 'Argentino',
    height: '1.79 m',
    since: 2023,
    stats: { partidos: 12, goles: 1, asistencias: 2 },
    bio: 'Volante de marca. Refuerza el mediocampo en partidos difíciles.',
  },
  {
    id: 15,
    number: 16,
    firstName: 'Nicolás',
    lastName: 'Vega',
    position: 'Mediocampista Ofensivo',
    positionShort: 'MCO',
    age: 20,
    nationality: 'Argentino',
    height: '1.72 m',
    since: 2024,
    stats: { partidos: 8, goles: 2, asistencias: 3 },
    bio: 'Promesa joven de las inferiores. Con llegada y buena pegada.',
  },
  {
    id: 16,
    number: 17,
    firstName: 'Ramiro',
    lastName: 'Acosta',
    position: 'Extremo',
    positionShort: 'EXT',
    age: 24,
    nationality: 'Argentino',
    height: '1.76 m',
    since: 2022,
    stats: { partidos: 11, goles: 3, asistencias: 4 },
    bio: 'Puede jugar por ambas bandas. Hábil y encarador.',
  },
  {
    id: 17,
    number: 19,
    firstName: 'Sebastián',
    lastName: 'Paz',
    position: 'Delantero',
    positionShort: 'DC',
    age: 26,
    nationality: 'Argentino',
    height: '1.85 m',
    since: 2021,
    stats: { partidos: 13, goles: 5, asistencias: 1 },
    bio: 'Delantero de área, fuerte en el juego aéreo.',
  },
  {
    id: 18,
    number: 20,
    firstName: 'Matías',
    lastName: 'Herrera',
    position: 'Delantero Juvenil',
    positionShort: 'DC',
    age: 19,
    nationality: 'Argentino',
    height: '1.78 m',
    since: 2025,
    stats: { partidos: 5, goles: 2, asistencias: 1 },
    bio: 'Debutante en primera esta temporada. Gran futuro por delante.',
  },
];

// — Equipo de Bochas
export const bochasTeam = {
  name: 'Equipo de Bochas',
  categoria: 'Primera División — Federación Cordobesa',
  capitan: 'Ernesto Maldonado',
  titulos: [
    'Campeón Liga Regional 2022',
    'Subcampeón Copa Provincial 2023',
    'Campeón Torneo Sierras 2024',
  ],
  entrenador: 'Raúl Domínguez',
  players: [
    {
      id: 101,
      firstName: 'Ernesto',
      lastName: 'Maldonado',
      role: 'Capitán — Punto',
      age: 58,
      since: 1998,
      bio: 'Capitán histórico del equipo. Más de 25 años defendiendo los colores del club.',
      stats: { torneos: 42, titulos: 8, promedio: '89%' },
    },
    {
      id: 102,
      firstName: 'Carlos',
      lastName: 'Giménez',
      role: 'Arrimador',
      age: 52,
      since: 2005,
      bio: 'Referente técnico y uno de los mejores arrimadores de la región.',
      stats: { torneos: 36, titulos: 6, promedio: '85%' },
    },
    {
      id: 103,
      firstName: 'Roberto',
      lastName: 'Luna',
      role: 'Bochador',
      age: 47,
      since: 2011,
      bio: 'Potencia y precisión en sus lanzamientos. Especialista en bochazos decisivos.',
      stats: { torneos: 28, titulos: 4, promedio: '82%' },
    },
    {
      id: 104,
      firstName: 'Jorge',
      lastName: 'Palacios',
      role: 'Punto',
      age: 44,
      since: 2014,
      bio: 'Juega cada tiro con la cabeza fría. Estratega del equipo.',
      stats: { torneos: 24, titulos: 3, promedio: '84%' },
    },
    {
      id: 105,
      firstName: 'Daniel',
      lastName: 'Ferreyra',
      role: 'Arrimador — Suplente',
      age: 39,
      since: 2018,
      bio: 'Joven promesa del equipo. Suple cualquier posición con solvencia.',
      stats: { torneos: 18, titulos: 2, promedio: '80%' },
    },
    {
      id: 106,
      firstName: 'Hugo',
      lastName: 'Benítez',
      role: 'Bochador — Suplente',
      age: 41,
      since: 2017,
      bio: 'Incorporado hace unas temporadas. Ya es parte fundamental del plantel.',
      stats: { torneos: 20, titulos: 3, promedio: '81%' },
    },
  ],
};
